// extracted by mini-css-extract-plugin
export default {"main":"FilterForm_main__0f49g","main-btn":"FilterForm_main-btn__apWjf"};